import React, { forwardRef, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { SnackbarContext } from '@eas/common-web';
import {
  canMuzaResync,
  handleSubmitResync,
} from '@modules/work-order/work-order-actionbar';
import { WorkOrder } from '@models';

type MenuItemProps = {
  closeMenu: () => void;
  workOrder: WorkOrder;
};

export const ResyncWoMenuItem = forwardRef<HTMLLIElement, MenuItemProps>(
  function ResyncWoMenuItem({ closeMenu, workOrder }, ref) {
    const { showSnackbar } = useContext(SnackbarContext);
    const disabled = !canMuzaResync(workOrder);

    return (
      <MenuItem
        ref={ref}
        disabled={disabled}
        onClick={async () => {
          await handleSubmitResync({
            id: workOrder.id,
            showSnackbar,
          });
          closeMenu();
        }}
      >
        <ListItemIcon>
          <SystemUpdateAltIcon fontSize="small" />
        </ListItemIcon>
        <FormattedMessage id="e" defaultMessage="Synchronizovať" />
      </MenuItem>
    );
  }
);
